import { render } from "./MyAuth.vue?vue&type=template&id=6d785cbf&scoped=true"
import script from "./MyAuth.vue?vue&type=script&lang=js"
export * from "./MyAuth.vue?vue&type=script&lang=js"

import "./MyAuth.vue?vue&type=style&index=0&id=6d785cbf&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6d785cbf"

export default script